// src/lib/api.js
import axios from "axios";

function getApiBase() {
  if (typeof window === "undefined") return "/api"; // SSR/tests fallback
  return `${window.location.origin}/api`;
}

const instance = axios.create({
  baseURL: getApiBase(),
  withCredentials: true, // keep if you use cookies/session
});

export default instance;
